/** Match server `slugifyOrgName` — preview only; API allocates final slug + uniqueness. */
export function slugifyOrgNamePreview(input: string): string {
  return (
    String(input)
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 48) || "org"
  );
}
